import React from 'react';

const AutomationErrorLogHeading = ({ history }) => {
  return (
    <>
      <h1 className="title gray-800 mb-0">
        <span
          className="pointer sendto-back"
          onClick={() => {
            history?.push('/workflow-automation');
          }}
        >
          Automation
        </span>
        <span> / Error Logs</span>
      </h1>
    </>
  );
};

export default AutomationErrorLogHeading;
